module.exports = __webpack_public_path__ + "media/images/bar_chart_explained-3b3f68de.jpg";